import React from 'react'
// Hooks
import usePerformanceTracker from 'src/viewLayer/components/hooks/usePerformanceTracker'
import safeLocalStorage from 'src/viewLayer/helpers/safeLocalStorage'

import EmailLoginFlow from '../flows/EmailLoginFlow'
// Components
import NavBar from './NavBar'

export default function LoginPages(properties) {
  usePerformanceTracker()
  const localStorageEmail = JSON.parse(safeLocalStorage.get('userInput'))?.email

  return (
    <>
      <NavBar />
      <EmailLoginFlow appType={properties.appType} localStorageEmail={localStorageEmail} />
    </>
  )
}
